const queryFromFilter = filter => {
    const match = String(filter || "").match(/query eq '((?:''|[^'])*)'/i);
    return match ? match[1].replace(/''/g, "'").toLowerCase() : "";
};

const objectTypesFromFilter = filter => {
    const value = String(filter || "");
    const equalsMatch = value.match(/objectType eq '([^']+)'/i);
    if (equalsMatch) {
        return [equalsMatch[1].toUpperCase()];
    }

    const inMatch = value.match(/objectType in \(([^)]+)\)/i);
    if (!inMatch) {
        return [];
    }

    const types = [];
    const typePattern = /'([^']+)'/g;
    let match;
    while ((match = typePattern.exec(inMatch[1]))) {
        types.push(match[1].toUpperCase());
    }
    return types;
};

const searchableText = item => {
    const ancestorValues = (item?.ancestors || []).reduce((values, ancestor) => {
        if (!ancestor || typeof ancestor !== "object") {
            return values;
        }
        return values.concat(Object.values(ancestor).filter(value => typeof value === "string"));
    }, []);

    return [
        item?.displayName,
        item?.title,
        item?.name,
        ...ancestorValues
    ].filter(Boolean).join(" ").toLowerCase();
};

export const handleGlobalSearchRequest = (fixture, request) => {
    const items = Array.isArray(fixture?.items) ? fixture.items : [];
    const filter = request?.queryParams?.filter || "";
    const query = queryFromFilter(filter);
    const objectTypes = objectTypesFromFilter(filter);

    const matches = items.filter(item => {
        const matchesType = !objectTypes.length || objectTypes.includes(String(item?.objectType || "").toUpperCase());
        const matchesQuery = !query || searchableText(item).includes(query);
        return matchesType && matchesQuery;
    });

    const requestedLimit = Number(request?.queryParams?.limit);
    const hasLimit = Number.isFinite(requestedLimit) && requestedLimit >= 0;

    return {
        ...fixture,
        count: matches.length,
        items: hasLimit ? matches.slice(0, requestedLimit) : matches
    };
};
